import type { ReactNode } from 'react';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import type { IconProps } from '@/components/Icon';
import { Icon } from '@/components/Icon';
import { LegacyButton } from '@/components/LegacyButton';

export interface SecondaryCTAProps {
  items: {
    icon: IconProps['name'];
    message: ReactNode;
    onClick?: () => void;
  }[];
}

export const SecondaryCTA = ({ items }: SecondaryCTAProps) => {
  return (
    <Box data-testid='SecondaryCTA'>
      {items.map(({ icon, message, onClick }, i) => (
        <Flex key={i}>
          <LegacyButton
            data-testid={`SecondaryCTAItem-${i}`}
            label={message}
            leftContent={<Icon color='primaryDark' name={icon} size='s' />}
            mt={2}
            onClick={onClick}
            size='l'
            variant='link'
            width='auto'
          ></LegacyButton>
        </Flex>
      ))}
    </Box>
  );
};
